import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useCookies } from 'vue3-cookies'
import VueGtag, { config } from 'vue-gtag'
import mitt from 'mitt'
import App from './App.vue'
import router from './router'
import { useFlowControlsStore } from '@/stores/flowControls'
import { requestIdleCallback } from '@/plugins/global'
import { stanAnalytics, loadStanAnalytics } from '@/plugins/stan-analytics'
import { configSettings } from './plugins/config-settings'
import cookieBanner from '@/plugins/cookieBanner'
import axios from 'axios'
import '@/assets/styles/variables.scss'
import '@/assets/styles/scroll-reveals.scss'
import TopNavigation from './components/TopNavigation'
import FooterNavigation from './components/FooterNavigation'
import CONSTANTS from './helpers/constants'
import VueGtm from 'vue-gtm'
import { AdsTracking } from '@/plugins/ads-tracking'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
const emitter = mitt()
app.config.globalProperties.$emitter = emitter
app.provide('configSettings', configSettings)
app.provide('_stan_app_emitter_', emitter)

app.component('TopNavigation', TopNavigation)
app.component('FooterNavigation', FooterNavigation)

const { cookies } = useCookies()
app.provide('cookies', cookies)
app.provide('stanAnalytics', stanAnalytics)
app.use(cookieBanner)

window.stanAnalyticsApiUrl = configSettings.stanAnalyticsApiUrl
const fcStore = useFlowControlsStore()
fcStore.$reset()
const analyticsLoadedInterval = setInterval(() => {
	// !window?.cookieBannerInitialized is falsy, this will only be bypassed if explicitly set to true
	// we don't care about the value of `accepted_cookies` since all functionality is blocked by their specfic cookie requirement
	// `!window?.noCookieConfirmationNeeded` is falsy, so this will only be bypassed if explicitly set to true

	if (!window?.cookieBannerInitialized || (!cookies.get('accepted_cookies') && !window?.noCookieConfirmationNeeded)) {
		return
	}

	const performanceAllowed = cookies.get('performance_cookies') === 'true' || window?.noCookieConfirmationNeeded
	const targetingAllowed = cookies.get('targeting_cookies') === 'true' || window?.noCookieConfirmationNeeded

	if (performanceAllowed && !window.stanAnalytics) {
		loadStanAnalytics(configSettings.stanAnalyticsUrl)
	}

	if (configSettings.environment === 'production' && targetingAllowed && fcStore.fcpComplete && !fcStore.vueGtagInstall) {
		requestIdleCallback(() => {
			AdsTracking('Initialize')
			app.use(VueGtm, {
				id: CONSTANTS.GOOGLE_TAG_MANAGER_ID,
				enabled: true,
				debug: true,
				vueRouter: router,
				trackOnNextTick: false,
			})
			app.use(
				VueGtag,
				{
					includes: [{ id: CONSTANTS.GOOGLE_AD_CONVERSION_ID, params: { send_page_view: false } }],
					config: { id: CONSTANTS.GOOGLE_GA4_MEASUREMENT_ID, params: { send_page_view: false } },
					enabled: configSettings.nodeEnvironment === 'production',
					onReady() {
						const adminDomain = configSettings.adminUrl.split('://')[1]
						const landingDomain = configSettings.defaultStoreUri.split('://')[1]
						config({
							linker: {
								domains: [adminDomain, landingDomain],
								accept_incoming: true,
								url_position: 'query',
							},
						})
					},
				},
				router
			)
			fcStore.$patch({ vueGtagInstall: true })
		})
	}
	clearInterval(analyticsLoadedInterval)
}, 1000)

axios
	.get('v1/get-ip')
	.then(response => {
		fcStore.$patch({ ipAddress: response.data.ip })
	})
	.catch(err => {
		console.warn(err)
	})

app.mount('#app')
